import { Component, OnInit, Input } from '@angular/core';

import { AppComponent } from '../app.component';
import { ViewEncapsulation } from '@angular/core'

@Component({
  standalone: false,
  selector: 'pnl-profile-card4',
  templateUrl: './z-pnl-profile-card4.component.html',
  styleUrls: ['./z-pnl-profile-card4.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class pnlProfileCard4 implements OnInit {

  @Input() aPanelData: any;

  constructor( public app: AppComponent ) { }

  ngOnInit() {
  }

}
